<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..."
  type="ball-scale-multiple"></ngx-spinner>
<app-header></app-header>
<div #noubaPage class="container-fluid">
  <div class="row">
    <div class="col-lg-8 col-md-8">
      <div class="noubaUploadHeading">
          {{'Nouba Upload' | translate}}
      </div>
    </div>
    <div class="col-lg-2 col-md-4 downloadTemplate">
      <div class="addNoubaInfo">
        <button class="btn btn-dark" (click)="openAddNouba()">
            {{'Add One Nouba Code' | translate}}
          </button>
    </div>
    </div>
    <div class="col-lg-2 col-md-4 downloadTemplate">
      <button class="btn btn-dark" (click)="downloadNoubaCodesTemplate()">
        <i class="fa fa-download" aria-hidden="true"></i>&nbsp;&nbsp;{{'Nouba Template file' | translate}}</button>
    </div>
    <!-- <div class="col-lg-2 col-md-4 formFontSection">
      <div class="btn-group" role="group" aria-label="Basic example">
        <button type="button" class="btn btn-danger btn-sm" (click)="changeFont('-')">
          <mat-icon>remove</mat-icon>
        </button>
        <button type="button" class="btn btn-light btn-sm">{{'Font Size' | translate}}</button>
        <button type="button" class="btn btn-success btn-sm" (click)="changeFont('+')">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </div> -->
  </div>

  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-8 col-md-8">
        <div class="row buildingNumberRow">
          <div class="col">
            <label class="buildingLabel">{{'Building Number' | translate}}</label>
          </div>
          <div class="col">
            <mat-select class="selectBuildingNumber" placeholder="Building Number" (change)="onBuildingChange($event)" [formControl]="buildings" multiple>
              <mat-select-trigger>
                <mat-chip-listbox>
                  <mat-chip class="buildingChips" *ngFor="let build of buildings.value" [removable]="true"
                    (remove)="onBuildingRemoved(build)">
                    {{ build }}
                    <mat-icon matChipRemove>cancel</mat-icon>
                  </mat-chip>
                </mat-chip-listbox>
              </mat-select-trigger>
              <mat-option *ngFor="let building of buildingNumberList" [value]="building">{{building}}</mat-option>
            </mat-select>
          </div>
          <div class="col">
            <button class="btn btn-outline-success searchBuildingButton" [disabled]="buildingArrLength === 0" type="button"
              (click)="searchByBuildingNumber()">{{'Search' | translate}}</button>
            <button class="btn btn-outline-success searchBuildingButton btnSpace" type="button"
              (click)="resetSearch()">{{'Reset Search' | translate}}</button>
          </div>
        </div>

        <div class="row noubaCodeRow">
          <div class="col">
            <label class="noubaLabel">{{'Nouba Code' | translate}}</label>
          </div>
          <div class="col">
              <input class="noubaInput" type="text" placeholder="Nouba Code" #noubaCodeInput matInput (input)="getNoubaCodeChar($event)"
                [matAutocomplete]="auto">
              <mat-autocomplete #auto="matAutocomplete">
                <span *ngIf="noubaCodeFilteredOptions">
                    <mat-option *ngFor="let option of noubaCodeFilteredOptions" [value]="option">
                        {{option}}
                      </mat-option>
                </span>
                <span *ngIf="noNoubaCodeRecords.length !== 0">
                    <mat-option>
                        {{'No Nouba Codes found' | translate}}
                        <!-- {{noNoubaCodeRecords}} -->
                      </mat-option>
                </span>
              </mat-autocomplete>
              <!-- <mat-hint *ngIf="noNoubaCodeRecords.length !== 0"></mat-hint> -->
          </div>
          <div class="col">
            <button class="btn btn-outline-success searchBuildingButton" type="button"
              (click)="searchByNoubaCode()" [disabled]="noubaCodeLength < 1 || noubaCodeLength > 3">{{'Search' | translate}}</button>
          </div>
        </div>
        <div class="row">
          <div class="col-6 exampleText">
            {{'Can be filtered by inputting *Value (ex.*TW)' | translate}}
          </div>
        </div>
      </div>

     

      <div class="col-lg-4 col-md-4 noubaBuildingIconColumn">
        <div class="row">
          <div class="col">
            <label class="noubaMap" for="">
              <img src="../../../assets/nouba-map-icon.svg" alt="">
            </label>
            <div style="text-align: center">
                {{'Nouba Map' | translate}}
            </div>
          </div>
          <div class="col">
            <label class="uploadNouba" for="noubaInputFile">
              <img src="../../../assets/Frame 2.svg" alt="">
            </label>
            <div style="text-align: center">
                {{'Upload' | translate}}
            </div>
            <input type="file" #noubaInput id="noubaInputFile" (change)="onFileChange($event)" style="display: none" />
          </div>
          <div class="col">
            <label (click)="downloadNoubaCSV()" class="downloadNouba" for="">
              <img src="../../../assets/downloadIcon.svg" alt="">
            </label>
            <div style="text-align: center">
                {{'Download' | translate}}
            </div>
          </div>
          <!-- <div class="col">
            <label (click)="goTo()" class="returnToDashboard" for="">
              <img src="../../../assets/Frame 1.svg" alt="">
            </label>
            <div style="text-align: center">
                {{'Return to Dashboard' | translate}}
            </div>
          </div> -->
        </div>

      </div>
    </div>
  </div>
  <!-- <div class="addNoubaInfo">
      <button class="btn btn-dark" (click)="openAddNouba()">
          Add Nouba Info
        </button>
  </div> -->
  <div class="noubaTable">
    <div class="row">
        <div class="col">
          <div class="groupDelete">
              <button [disabled]="!selection.selected.length" class="btn btn-dark" (click)="deleteBulkData()">{{'Group Delete' | translate}}</button>
          </div>
        </div>
        <div class="col">
            <div class="units">
                {{'unit:m(meter)' | translate }}
           </div>
        </div>
      </div>
    
    <div class="example-container mat-elevation-z8" >
      <mat-table #table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)">

          <ng-container matColumnDef="select">
              <mat-header-cell *matHeaderCellDef>
                <mat-checkbox (change)="$event ? masterToggle() : null"
                              [checked]="selection.hasValue() && isAllSelected()"
                              [indeterminate]="selection.hasValue() && !isAllSelected()">
                </mat-checkbox>
              </mat-header-cell>
              <mat-cell *matCellDef="let row">
                <mat-checkbox (click)="$event.stopPropagation()"
                              (change)="$event ? selection.toggle(row) : null"
                              [checked]="selection.isSelected(row)">
                </mat-checkbox>
              </mat-cell>
            </ng-container>

        <ng-container matColumnDef="noubaCode">
          <mat-header-cell *matHeaderCellDef mat-sort-header> {{'Nouba Code' | translate}} </mat-header-cell>
          <mat-cell *matCellDef="let element" (dblclick)="editRow(element)"> {{element.noubaCode}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="drivingDirection">
          <mat-header-cell *matHeaderCellDef mat-sort-header> {{'Driving Direction' | translate}} </mat-header-cell>
          <mat-cell *matCellDef="let element" (dblclick)="editRow(element)"> {{element.drivingDirection}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="x">
          <mat-header-cell *matHeaderCellDef mat-sort-header> {{'Coordinate X' | translate}} </mat-header-cell>
          <mat-cell *matCellDef="let element" (dblclick)="editRow(element)"> {{element.x}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="y">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{'Coordinate Y' | translate}} </mat-header-cell>
          <mat-cell *matCellDef="let element" (dblclick)="editRow(element)"> {{element.y}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="depth">
          <mat-header-cell *matHeaderCellDef mat-sort-header> {{'Size Depth(X)' | translate}} </mat-header-cell>
          <mat-cell *matCellDef="let element" (dblclick)="editRow(element)"> {{element.depth}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="width">
          <mat-header-cell *matHeaderCellDef mat-sort-header> {{'Size Width(Y)' | translate}} </mat-header-cell>
          <mat-cell *matCellDef="let element" (dblclick)="editRow(element)"> {{element.width}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="building">
          <mat-header-cell *matHeaderCellDef mat-sort-header> {{'Building Number' | translate}} </mat-header-cell>
          <mat-cell *matCellDef="let element" (dblclick)="editRow(element)"> {{element.building}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="history">
          <mat-header-cell *matHeaderCellDef> {{'History' | translate}} </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <mat-icon class="history" (click)="showHistory(element)">history</mat-icon>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="delete">
            <mat-header-cell *matHeaderCellDef>{{'Delete' | translate}}</mat-header-cell>
            <mat-cell *matCellDef="let element">
              <mat-icon (click)="deleteNoubaData(element.noubaCode)"  class="delete">delete</mat-icon>
            </mat-cell>
          </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)"></mat-row>

      </mat-table>
      <div class="noRecord" *ngIf="length === 0">
        <span>{{'No Record Found' | translate}}</span>
      </div>
      <mat-paginator *ngIf="length !== 0" #paginator [length]="length" [pageSizeOptions]="pageSizeOptions"
        [pageSize]="pageSize" [showFirstLastButtons]="true" (page)="handleNoubaPage($event, length)">
      </mat-paginator>
    </div>
    
  </div>

</div>
